export default __webpack_public_path__ + "static/media/liftBg.74be0634.png";